import { ReactNode, useState } from "react";
import { ProfileProvider } from "@hooks/context/useProfileContext";
import Header2 from "./MainLayout/Header2";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Toolbar,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import useConfig from "@hooks/utils/useConfig";
import LAYOUT_CONST from "constant";
import { LayoutGroupContext } from "framer-motion";
import LayoutWrapper from "@stories/pages/Authenticate/AuthWrapper1";

interface PermitLayoutProps {
  children: ReactNode;
}

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const NoMenuLayout = (props: PermitLayoutProps) => {
  const { children } = props;

  const theme = useTheme();
  const [isDrawOpen, setIsDrawOpen] = useState(true);
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));

  const { layout } = useConfig();

  const condition = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd;

  const header = (
    <Toolbar sx={{ p: condition ? "10px" : "16px" }}>
      <Header2 setIsDrawOpen={setIsDrawOpen} isDrawOpen={isDrawOpen} />
    </Toolbar>
  );
  return (
    <LayoutWrapper>
      <ProfileProvider>
        <AppBar
          enableColorOnDark
          position="fixed"
          color="inherit"
          elevation={0}
          sx={{ bgcolor: theme.palette.background.default }}
        >
          {header}
        </AppBar>
        <Main>
          <Container maxWidth="xl">{children}</Container>
        </Main>
      </ProfileProvider>
    </LayoutWrapper>
  );
};
